/* storybook-check-ignore */
import React from 'react';
import { Flex, Text, Link, Icon, Button } from '@opendoor/bricks/core';
import { Avatar } from '@opendoor/bricks/complex';
import SelectiveSpritesheet from '@opendoor/bricks/core/Icon/SelectiveSpritesheet';
import EmailFilled from '@opendoor/bricks/core/Icon/SpritesheetIcons/EmailFilled';
import PhoneFilled from '@opendoor/bricks/core/Icon/SpritesheetIcons/PhoneFilled';

interface AgentExperiencePartnerCTAProps {
  aepFirstName?: string | string[] | null;
  aepInitials?: (string | undefined)[] | undefined;
  aepEmail?: string | string[] | undefined;
  aepPhone?: string | string[] | null;
}

const AgentExperiencePartnerCTA: React.FC<AgentExperiencePartnerCTAProps> = ({
  aepEmail,
  aepFirstName,
  aepInitials,
  aepPhone,
}) => {
  return (
    <>
      <Flex mt={[6, null, 0]} mb={[0, 0, 5]}>
        <Avatar
          src="http://www.example.com/badimage.png"
          size="md"
          disabled={false}
          initials={aepInitials?.join('') || ''}
        />
        <Flex flexDirection="column" alignItems="flex-start" ml={7}>
          <Text fontSize="s1" color="neutrals100" fontWeight="semibold">
            {aepFirstName} {aepInitials && aepInitials[1]?.concat('.')}
          </Text>
          <Text fontSize="s0" color="neutrals90" mb={4}>
            Opendoor Co-Listing Agent
          </Text>
          <Link
            aria-label="Email Opendoor co-listing agent"
            analyticsName="cosmos-pdp-email-listing-agent"
            fontSize="s0"
            color="brand50"
            fontWeight="semibold"
            href={`mailto:${aepEmail}`}
          >
            <SelectiveSpritesheet icons={[EmailFilled]} />
            <Icon name="email-filled" color="brand50" size={12} mr={3} />
            {aepEmail}
          </Link>
          <Text fontSize="s0" color="brand50" fontWeight="semibold">
            <SelectiveSpritesheet icons={[PhoneFilled]} />
            <Icon name="phone-filled" color="brand50" size={12} mr={3} />
            Call or text: {aepPhone}
          </Text>
        </Flex>
      </Flex>
      <Button
        aria-label="Schedule with ShowingTime"
        width="100%"
        onClick={() => window.open('https://www.showingtime.com/login', '_blank')}
        variant="primary"
        analyticsName="'cosmos-pdp-schedule-with-showingtime'"
        mt={[5, null, 0]}
      >
        Schedule with ShowingTime
      </Button>
      <Button
        width="100%"
        onClick={() => {}}
        variant="secondary"
        aria-label=""
        analyticsName=""
        mt={5}
      >
        <Link
          href="tel:800-746-9464"
          aria-label="Contact ShowingTime at 800-746-9464"
          analyticsName="cosmos-call-showingtime"
        >
          <Text color="neutrals100" fontWeight="semibold" fontSize="s1">
            Call 800-SHOWING
          </Text>
        </Link>
      </Button>
    </>
  );
};

export default AgentExperiencePartnerCTA;
